import { WinnerSelectorController, WinnerSelector } from "components/Pages/Tournament/WinnerSelector";
import { injectModal } from "lib/injectParams";

// WinnerSelector is the component without injectModal, so we wrap it here
export default injectModal(WinnerSelectorController.scope(WinnerSelector));
